<div class="container">
  <label
    [for]="id"
    [class.error]="messageError"
    [class.filled]="value"
  >{{label}}</label>
  <div class="input-box">
    <input
      [id]="id"
      [name]="name"
      [placeholder]="placeholder"
      [type]="type"
      [class.error]="messageError"
      [class.type-text]="!typeIsPassword"
      [ngModel]="value"
      (ngModelChange)="onInputChange($event)"
      [autocomplete]="autocomplete"
      [mask]="mask"
      [dropSpecialCharacters]="dropSpecialCharacters"
      [disabled]="disabled"
      [attr.maxlength]="maxlength ? maxlength : null"
    />
    <button
      type="button"
      *ngIf="typeIsPassword"
      (click)="onChangeVisibility()"
    >
      <i
        class="fa "
        [class.fa-eye] = "!visibilityPassword"
        [class.fa-eye-slash] = "visibilityPassword"
        [ngClass]="{'fa-eye': !visibilityPassword, 'fa-eye-slash': visibilityPassword}"
        aria-hidden="true"
      ></i>
    </button>
  </div>
  <div *ngIf="showMaxLengthMessage" class="max-length-message">
    Este campo aceita no máximo {{ maxlength }} caracteres.
  </div>
  <div *ngIf="messageError" class="error error-message">{{messageError}}</div>
</div>
